import { useCallback } from 'react';

export default function useArtistEventChatMembershipRevocation({
  selectedEventIdRef,
  selectedThreadIdRef,
  chatTopics,
  clearLast,
  pendingRestoreRef,
  setSelectedEventId,
  setSelectedEventInfo,
  setMessages,
  setReplyDraft,
  setShowNotes,
  setShowAlbumModal,
  setShowMaterialsModal,
  setShowNewMsgBanner,
  setIsMemberModalOpen,
  setShowMediaModal,
  setShowLinksModal,
  closeProfileModal,
  closeReactionDetail,
  setMessageMenu,
  setOffset,
  setMobileView,
  toastInfo,
  navigate
}: Record<string, any>) {
  return useCallback(() => {
    selectedEventIdRef.current = null;
    selectedThreadIdRef.current = null;
    chatTopics.modeKey = `${chatTopics.modeKey}:revoked`;
    chatTopics.enabled = false;
    clearLast();
    pendingRestoreRef.current = false;
    setSelectedEventId(null);
    setSelectedEventInfo(null);
    setMessages([]);
    setReplyDraft(null);
    setShowNotes(false);
    setShowAlbumModal(false);
    setShowMaterialsModal(false);
    setShowNewMsgBanner(false);
    setIsMemberModalOpen(false);
    setShowMediaModal(false);
    setShowLinksModal(false);
    closeProfileModal();
    closeReactionDetail();
    setMessageMenu(null);
    setOffset(0);
    setMobileView('list');
    toastInfo('このチャットへの参加が解除されました。');
    navigate('/artist/workspaces/event-operations/event-chat', { replace: true, state: null });
  }, [selectedEventIdRef, selectedThreadIdRef, chatTopics, clearLast, pendingRestoreRef, setSelectedEventId, setSelectedEventInfo, setMessages, setReplyDraft, setShowNotes, setShowAlbumModal, setShowMaterialsModal, setShowNewMsgBanner, setIsMemberModalOpen, setShowMediaModal, setShowLinksModal, closeProfileModal, closeReactionDetail, setMessageMenu, setOffset, setMobileView, toastInfo, navigate]);
}
